import { render, staticRenderFns } from "./partnership-logo.component.vue?vue&type=template&id=4f2b12a8&scoped=true&"
import script from "./partnership-logo.component.vue?vue&type=script&lang=ts&"
export * from "./partnership-logo.component.vue?vue&type=script&lang=ts&"
import style0 from "./partnership-logo.component.vue?vue&type=style&index=0&id=4f2b12a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2b12a8",
  null
  
)

export default component.exports